<hr />
<div class="form-group position-relative row mt-3">
  <div class="col">
    @if (props.header) {
      <h2
        class="fw-light"
      >{{ props.header }}</h2>
    }
  </div>

  @if (props.headerTooltip) {
    <div
      class="template-tooltip col-1"
      >
      <i
        class="col-1 far fa-question-circle my-auto"
        (click)="openTooltip()"
      ></i>
    </div>
  }
</div>
